import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { StudentsService } from '@services/students/students.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cambiar-password',
  templateUrl: './cambiar-password.component.html',
  styleUrls: ['./cambiar-password.component.scss']
})
export class CambiarPasswordComponent {

  form: UntypedFormGroup;

  constructor(
    private studentsService: StudentsService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<CambiarPasswordComponent>
  ) {
    this.form = new UntypedFormGroup({
      password: new UntypedFormControl(null, [Validators.required, Validators.minLength(6)]),
      password_confirmation: new UntypedFormControl(null, [Validators.required])
    });
  }

  guardar(): void {
    if (this.form.invalid) {
      this.toastr.error('Complete el formulario');
      return;
    }

    if (this.form.value.password !== this.form.value.password_confirmation) {
      this.toastr.error('Las contraseñas no coinciden');
      return;
    }

    this.spinner.show();
    this.studentsService.cambiarPassword(this.form.value).subscribe({
      next: () => {
        this.spinner.hide();
        this.toastr.success('Contraseña actualizada correctamente');
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.spinner.hide();
        this.toastr.error(err?.error?.message || 'No se pudo actualizar la contraseña');
      }
    });
  }

}
